// extracted by mini-css-extract-plugin
module.exports = {"topImage":"tips_topImage__2-iX7","content":"tips_content__pI1Zc","title":"tips_title__2_vKd"};